import { Bar, BarChart, CartesianGrid, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';
import { CardGrafico } from './CardGrafico';
import { useChartTheme } from './ChartTheme';
import { fmtBRL, fmtBRLcompacto, fmtMesAno } from './formatadores';
import type { DashboardFinanceiro } from '../../types';

export function GraficoRecebimentoMensal({ dados }: { dados: DashboardFinanceiro['por_mes'] }) {
  const t = useChartTheme();
  const data = dados.map((d) => ({ ...d, rotulo: fmtMesAno(d.mes) }));
  return (
    <CardGrafico titulo="Fluxo de caixa (recebido por mês)" vazio={!data.length} msgVazio="Nenhum recebimento registrado ainda">
      <ResponsiveContainer width="100%" height="100%">
        <BarChart data={data} margin={{ top: 8, right: 8, left: 4, bottom: 0 }}>
          <CartesianGrid strokeDasharray="3 3" stroke={t.grid} vertical={false} />
          <XAxis dataKey="rotulo" tick={{ fontSize: 11, fill: t.texto }} axisLine={{ stroke: t.grid }} tickLine={false} />
          <YAxis tickFormatter={(v) => fmtBRLcompacto(v as number)} tick={{ fontSize: 11, fill: t.texto }} axisLine={false} tickLine={false} width={64} />
          <Tooltip
            cursor={{ fill: t.grid, opacity: 0.3 }}
            formatter={(v: number) => [fmtBRL(v), 'Recebido']}
            contentStyle={{ background: t.tooltipBg, border: `1px solid ${t.grid}`, borderRadius: 8, fontSize: 12, color: t.texto }}
          />
          <Bar dataKey="recebido" fill={t.recebido} radius={[4, 4, 0, 0]} maxBarSize={48} />
        </BarChart>
      </ResponsiveContainer>
    </CardGrafico>
  );
}
